export default function checkTopic(topic) {
  if (topic === "coding") {
    return "coding";
  } else if (topic === "cooking") {
    return "cooking";
  } else if (topic === "football") {
    return "football";
  }
}
